import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ClubsStore } from '../../../../clubs/clubs.store';
import { SelectedRoomsService } from '../../../../clubs/services/selected-rooms-service';
import { ClubRoom } from '../../../../models/clubs/club-room.model';
import { Club } from '../../../../models/clubs/club.model';

interface ClubWithRooms extends Club {
    room: ClubRoom[];
}

@Component({
    selector: 'app-select-rooms-accordion',
    styleUrls: ['./select-rooms-accordion.component.scss'],
    templateUrl: './select-rooms-accordion.component.html',
})
export class SelectRoomsAccordionComponent implements OnInit, OnChanges {
    @Input() public clubId: string;
    @Input() public defaultRoomId: string;
    @Input() public isModalOpen: boolean;
    @Input() public isVisible = false;
    public clubs: ClubWithRooms[] = [];
    public selectedRooms: { [clubId: string]: ClubRoom[] } = {};
    public roomMessageMapping = {
        '=1': this.translate.instant('clubs.page.common.createPublication.rooms.oneRoomSelected'),
        other: this.translate.instant('clubs.page.common.createPublication.rooms.roomsSelected'),
    };

    constructor(
        private readonly clubsStore: ClubsStore,
        private readonly selectedRoomsService: SelectedRoomsService,
        private readonly translate: TranslateService,
    ) {}

    public ngOnInit(): void {
        this.initializeComponent();
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.clubId || changes.defaultRoomId || changes.isModalOpen) {
            this.handleModalLifecycle();
        }
    }
    handleModalLifecycle() {
        if (this.isModalOpen) {
            this.initializeComponent();
        } else {
            this.resetState();
        }
    }

    public getSelectedCount(clubId: string): number {
        return this.selectedRooms[clubId]?.length || 0;
    }

    public onRoomSelectionChange(): void {
        this.selectedRoomsService.updateSelectedRooms(this.selectedRooms);
    }

    private initializeComponent(): void {
        this.resetState();
        this.loadClubsAndRooms();
        this.initializeDefaultRoomSelection();
    }

    private resetState(): void {
        this.clubs = [];
        this.selectedRooms = {};
        this.selectedRoomsService.updateSelectedRooms({});
    }

    private initializeDefaultRoomSelection(): void {
        this.selectedRooms = {};
        const targetClub = this.clubs.find((club) => club.id === this.clubId);

        if (targetClub && this.defaultRoomId) {
            const defaultRoom = targetClub.room.find((room) => room.id === this.defaultRoomId);
            if (defaultRoom) {
                this.selectedRooms[targetClub.id] = [defaultRoom];
                this.selectedRoomsService.updateSelectedRooms(this.selectedRooms);
            }
        }
    }

    private loadClubsAndRooms(): void {
        if (!this.clubsStore.member?.fullClubs) {
            return;
        }

        this.clubs = this.clubsStore.member.fullClubs.map((club) => ({
            ...club,
            room: this.clubsStore.getRooms(club),
        }));
    }
}
